import { render, staticRenderFns } from "./weixin.vue?vue&type=template&id=7d2a0e06&scoped=true"
var script = {}
import style0 from "./weixin.vue?vue&type=style&index=0&id=7d2a0e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2a0e06",
  null
  
)

export default component.exports